<template>
  <div
    class="__C_Section"
    :class="[currentMarginBottom]"
    :style="{ 'margin-bottom': currentMarginBottomStyle }"
  >
    <slot />

    <CSeparator spaced v-if="separate" />
  </div>
</template>

<script>
import Vue from 'vue';
import CSeparator from '@/components/uikit/CSeparator';

/**
 * [props]
 * marginBottom: sm, md, lg, xl, xxl, none, custom(2em, 5rem...) [default: md]
 */
export default Vue.extend({
  name: 'CSection',
  components: { CSeparator },
  props: {
    marginBottom: {
      type: String,
      default: 'md',
    },
    separate: {
      type: Boolean,
    },
  },
  computed: {
    currentMarginBottom() {
      if (!this.marginBottom) {
        return undefined;
      } else if (
        this.marginBottom !== 'sm' &&
        this.marginBottom !== 'md' &&
        this.marginBottom !== 'lg' &&
        this.marginBottom !== 'xxl' &&
        this.marginBottom !== 'none'
      ) {
        return undefined;
      }

      return `margin-bottom-${this.marginBottom}`;
    },

    currentMarginBottomStyle() {
      if (this.marginBottom && this.currentMarginBottom === undefined) {
        return this.marginBottom;
      }
      return undefined;
    },
  },
});
</script>

<style lang="scss" scoped>
.__C_Section {
  &.margin-bottom-none {
    margin-bottom: 0;
  }
  &.margin-bottom-sm {
    margin-bottom: $space-sm;
  }
  &.margin-bottom-md {
    margin-bottom: $space-md;
  }
  &.margin-bottom-lg {
    margin-bottom: $space-lg;
  }
  &.margin-bottom-xl {
    margin-bottom: $space-xl;
  }
  &.margin-bottom-xxl {
    margin-bottom: $space-xxl;
  }
}
</style>
